import apiFinancial from "../config/api_financial";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

export function indexAllBankAccountFarm(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/bank/accounts`,
    getHeaders(false, signal)
  );
}

export function indexAllDropdownBankAccountFarm(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/bank/accounts`,
    getHeaders(false, signal)
  );
}

export function saveOrUpdateBankAccountFarm(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  if (id) {
    if (body.farmId)
      return apiFinancial.patch(
        `/bovexo/${groupId}/farms/${farmId}/bank/accounts/${id}`,
        body,
        getHeaders(false, signal)
      );
    else
      return apiFinancial.patch(
        `/bovexo/${groupId}/farms/bank/accounts/${id}`,
        body,
        getHeaders(false, signal)
      );
  }

  if (body.farmId)
    return apiFinancial.post(
      `/bovexo/${groupId}/farms/${farmId}/bank/accounts`,
      body,
      getHeaders(false, signal)
    );
  return apiFinancial.post(
    `/bovexo/${groupId}/farms/bank/accounts`,
    body,
    getHeaders(false, signal)
  );
}

export function activateBankAccountFarm(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFinancial.patch(
    `/bovexo/${groupId}/farms/${farmId}/bank/accounts/${id}/activate`,
    null,
    getHeaders(false, signal)
  );
}

export function inactivateBankAccountFarm(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFinancial.patch(
    `/bovexo/${groupId}/farms/${farmId}/bank/accounts/${id}/inactivate`,
    null,
    getHeaders(false, signal)
  );
}
